module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre_15",
    attrs: {
      "id": "calibre_pb_30"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_vm._v("REALITY AND MANIFESTATION")])]), _vm._v(" "), _c('h2', {
    staticClass: "calibre_22",
    attrs: {
      "id": "filepos73149"
    }
  }, [_c('span', {
    staticClass: "calibre10"
  }, [_c('span', {
    staticClass: "italic1"
  }, [_vm._v("8 "), _c('img', {
    staticClass: "calibre11",
    attrs: {
      "alt": "image",
      "src": "images/00004.jpg"
    }
  }), _vm._v(" Free-will Versus Determinism")])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('div', {
    staticClass: "calibre_27"
  }, [_c('blockquote', {
    staticClass: "calibre13"
  }, [_c('div', {
    staticClass: "calibre5"
  }, [_c('p', {
    staticClass: "calibre_18"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Discussions concerning the predominance of the will over destiny, or vice versa, can only take place among those who lack knowledge of the root of both. Those who have knowledge of the Self, sole root of the will and of destiny, are free from the one and the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("After that how can they take part in such discussions?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_28"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMANA")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHARSHI")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLADU")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARPADU")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_28"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Forty Verses on the Knowledge of Being")]), _vm._v(", 19")])])])])]), _c('div', {
    staticClass: "calibre_14"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("An essential difference between a Jivan Mukta and an ordinary unenlightened man is that the former has transcended the duality inherent in that apparent contradiction of between Free-will and Determinism.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The Jivan Mukta, having abandoned the concept of an ego, subject to which the ordinary man lives, his will no longer has any alternative to complete harmony with that of the cosmic order, so that he “wills” what must be, without any kind of resistance (there being in him no longer any psychic mechanism capable of resistance), whereas the ordinary man, subject to his ego-concept, is unable to perceive what must be, and seeks to substitute the desires aggregated to his artificial “ego,” which he imagines he is free to fulfill if he can.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Neither is “free” in the sense thought of by the ordinary man, but the one experiences no lack of “freedom” or any constraint, whereas the other spends his life in an imaginary "), _c('a'), _vm._v("conflict, a tilting against wind-mills, trying to assert a “freedom” he could not possibly enjoy.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_19"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("That is why the Jivan Mukta lives his life without conflict, and usually devotes himself to helping the unenlightened to rid themselves of their errors by transcending the ego-concept, for on that plane, the plane of understanding, real understanding being in a further dimension that is not subject to the Space-Time mechanism, even the ordinary man is “free” (of the aforesaid mechanicity) to rid himself of his ignorance.")])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_31"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f23c5622","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_018.vue
// module id = 114
// module chunks = 0